import React from "react";
import { TooltipWithClose } from "../TooltipWithClose";
import { useTranslate } from "../../helpers/intlHooks";
import { FCWithChildren } from "../../@types";

export const TooltipExtraHelp: FCWithChildren = ({ children }) => {
  const t = useTranslate();
  return (
    <TooltipWithClose
      contentHeading={
        <div
          className="ds-text-heading--lg ds-u-margin-bottom--0"
          role="heading"
          aria-level={2}
        >
          {t("ntm.tooltip.extra_help.heading")}
        </div>
      }
      title={t("ntm.tooltip.extra_help.body")}
      className="ds-c-tooltip__trigger-link"
      component="a"
    >
      {children}
    </TooltipWithClose>
  );
};
